import { z } from "zod";

export const searchModelFormModel = z.object({
  model: z
    .object({
      modelCode: z.string().optional(),
      modelName: z.string().optional(),
    })
    .refine(
      (data) => {
        return data.modelCode?.trim() || data.modelName?.trim();
      },
      {
        path: ["model"],
      },
    ),
});

export type SearchModelFormModel = z.infer<typeof searchModelFormModel>;
